import { Box, Text, VStack } from "@chakra-ui/react"
import type { ReactNode } from "react"

interface FieldProps {
  label?: string
  required?: boolean
  invalid?: boolean
  errorText?: string
  helperText?: string
  children: ReactNode
}

export const Field = ({
  label,
  required,
  invalid,
  errorText,
  helperText,
  children,
}: FieldProps) => {
  return (
    <VStack gap={2} alignItems="flex-start" w="100%">
      {label && (
        <Text fontSize="sm" fontWeight="medium">
          {label}
          {required && (
            <Text as="span" color="red.500">
              {" "}
              *
            </Text>
          )}
        </Text>
      )}
      <Box w="100%">{children}</Box>
      {helperText && !invalid && (
        <Text fontSize="xs" color="gray.600">
          {helperText}
        </Text>
      )}
      {invalid && errorText && (
        <Text color="red.500" fontSize="sm">
          {errorText}
        </Text>
      )}
    </VStack>
  )
}

export default Field
